﻿<script setup>
    import { useDialogPluginComponent } from 'quasar'
    defineEmits([...useDialogPluginComponent.emits])
    const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()

    import Rest from '@/rest'

    const props = defineProps({
        section: String
    });

    //const user = ref(props.section);
    //const users = ref(['Production','Scheduling','Shipping','Sales']);;
    const code = ref('');
    const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, -1, 0, -2];

    //watch(user, validateAuth);
    watch(code, validateAuth);

    async function validateAuth() {
        //if (user.value && code.value.length == 4) {
        if (code.value.length == 4) {
            //validate
            try {
                var token = await Rest.Post('/api/auth/token', {
                    //User: user.value,
                    Code: code.value
                }, {
                    annonymous: true
                });
                onDialogOK(token);
            } catch {
                code.value = '';
            }
        }
    }

    async function enterNum(n) {
        if (n == -1) {
            onDialogCancel();
        }

        else if (n == -2) {
            if (!code.value.length) return;
            code.value = code.value.substring(0, code.value.length - 1);
            return;
        }

        else {
            if (code.value.length == 4) return;
            code.value += n;
        }
    }


</script>

<template>
    <q-dialog ref="dialogRef" @hide="onDialogHide" :persistent="true">
        <div w-64 bg-white p-4>
            <div text-center text-xl mb-3>
                Enter Code
            </div>
            <div mb-5>
                <q-form autocomplete="off">
                    <q-input v-model="code" 
                             type="password"
                             autofocus 
                             text-center 
                             text-xl
                             maxlength="4" />
                </q-form>
            </div>
            <div gf-3-3>
                <div v-for="n in numbers" text-center>
                    <q-btn v-if="n >= 0"
                           :label="n"
                           round
                           size="lg"
                           color="positive"
                           @click="enterNum(n)" />
                    <q-btn v-if="n == -1"
                           icon="clear"
                           round
                           size="lg"
                           color="negative"
                           @click="enterNum(n)" />
                    <q-btn v-if="n == -2"
                           icon="backspace"
                           round
                           size="lg"
                           color="warning"
                           @click="enterNum(n)" />
                </div>
            </div>
        </div>
    </q-dialog>
</template>

<style>
    .q-dialog .q-dialog__backdrop {
/*        background:rgb(0, 0, 0, 0.84);*/
    }
</style>